// Set copyright year
var year = document.getElementById('year');
if (year) {
  year.textContent = new Date().getFullYear();
}
